import { defineComponent as _defineComponent } from 'vue';
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeStyle as _normalizeStyle, createCommentVNode as _createCommentVNode, Transition as _Transition, withCtx as _withCtx, createBlock as _createBlock } from "vue";
const _hoisted_1 = ["width", "height", "viewBox"];
const _hoisted_2 = ["stroke-width"];
const _hoisted_3 = ["cx", "cy"];
const _hoisted_4 = ["dur", "values"];
const _hoisted_5 = ["cx", "cy"];
const _hoisted_6 = ["begin", "dur", "values"];
import { computed } from 'vue';
export default /*@__PURE__*/ _defineComponent({
    __name: 'Loader',
    props: {
        speed: {
            type: Number,
            default: 1,
        },
        size: {
            type: Number,
            default: 32,
        },
        thickness: {
            type: Number,
            default: 2,
        },
        color: {
            type: String,
            required: false,
        },
        show: {
            type: Boolean,
            default: true,
        },
    },
    setup(__props) {
        const props = __props;
        const inlineCss = computed(() => {
            const styles = {};
            if (props.color) {
                styles['--themeLoader-color'] = props.color;
            }
            return styles;
        });
        return (_ctx, _cache) => {
            return (_openBlock(), _createBlock(_Transition, null, {
                default: _withCtx(() => [
                    (__props.show)
                        ? (_openBlock(), _createElementBlock("div", {
                            key: 0,
                            class: "themeLoader",
                            style: _normalizeStyle(inlineCss.value)
                        }, [
                            (_openBlock(), _createElementBlock("svg", {
                                class: "themeLoader-element",
                                width: __props.size,
                                height: __props.size,
                                viewBox: `0 0 ${__props.size} ${__props.size}`,
                                xmlns: "http://www.w3.org/2000/svg"
                            }, [
                                _createElementVNode("g", {
                                    fill: "none",
                                    "fill-rule": "evenodd",
                                    "stroke-width": __props.thickness
                                }, [
                                    _createElementVNode("circle", {
                                        cx: __props.size / 2,
                                        cy: __props.size / 2,
                                        r: "1"
                                    }, [
                                        _createElementVNode("animate", {
                                            attributeName: "r",
                                            begin: "0s",
                                            dur: `${__props.speed * 1.8}s`,
                                            values: `1; ${__props.size * 0.5 - __props.thickness}`,
                                            calcMode: "spline",
                                            keyTimes: "0; 1",
                                            keySplines: "0.165, 0.84, 0.44, 1",
                                            repeatCount: "indefinite"
                                        }, null, 8, _hoisted_4),
                                        _cache[0] || (_cache[0] = _createElementVNode("animate", {
                                            attributeName: "stroke-opacity",
                                            begin: "0s",
                                            dur: "1.8s",
                                            values: "1; 0",
                                            calcMode: "spline",
                                            keyTimes: "0; 1",
                                            keySplines: "0.3, 0.61, 0.355, 1",
                                            repeatCount: "indefinite"
                                        }, null, -1))
                                    ], 8, _hoisted_3),
                                    _createElementVNode("circle", {
                                        cx: __props.size / 2,
                                        cy: __props.size / 2,
                                        r: "1"
                                    }, [
                                        _createElementVNode("animate", {
                                            attributeName: "r",
                                            begin: `-${__props.speed * 0.9}s`,
                                            dur: `${__props.speed * 1.8}s`,
                                            values: `1; ${__props.size * 0.5 - __props.thickness}`,
                                            calcMode: "spline",
                                            keyTimes: "0; 1",
                                            keySplines: "0.165, 0.84, 0.44, 1",
                                            repeatCount: "indefinite"
                                        }, null, 8, _hoisted_6),
                                        _cache[1] || (_cache[1] = _createElementVNode("animate", {
                                            attributeName: "stroke-opacity",
                                            begin: "-0.9s",
                                            dur: "1.8s",
                                            values: "1; 0",
                                            calcMode: "spline",
                                            keyTimes: "0; 1",
                                            keySplines: "0.3, 0.61, 0.355, 1",
                                            repeatCount: "indefinite"
                                        }, null, -1))
                                    ], 8, _hoisted_5)
                                ], 8, _hoisted_2)
                            ], 8, _hoisted_1))
                        ], 4))
                        : _createCommentVNode("", true)
                ]),
                _: 1
            }));
        };
    }
});
